import { render } from "./DialogCouponCodeFails.vue?vue&type=template&id=7ac9f517"
import script from "./DialogCouponCodeFails.vue?vue&type=script&lang=js"
export * from "./DialogCouponCodeFails.vue?vue&type=script&lang=js"
script.render = render

export default script